import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { RefTypeEnum } from '../../../enums/ref-type-enum';
import { PurposeEnum } from '../../../enums/purpose-enum';
import { StorageService } from '../../../../Common/services/storage.service';
import { BaseFileHandler } from '../base-file-handler';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FileUploadModel } from '../../../../shared/flexible-file-upload/flexible-file-upload.component';
import { MessageService } from '../../../services/message.service';
import { ProjectFilesVm, ProjectGeneralInfoVm, StoreValidationRequestVM, StoreValidationVM } from '../../../models/project-vm';
import { ConfirmationService } from 'primeng/api';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';
import { Category } from '../../../../administration/models/models-vm';
import { EmailNotificationService } from '../../../../Common/services/email-notification.service';
import { ProjectDto } from '../../../../Common/models/emailrequestdto';
import { ActionItems } from '../../../../Common/Constants/common.constants';
import { ProjectConstants } from '../../../constants/component-messages';

declare var $: any;

@Component({
  selector: 'app-common-store-list',
  templateUrl: './common-store-list.component.html',
  styleUrl: './common-store-list.component.css'
})
export class CommonStoreListComponent
  extends BaseFileHandler<Blob, File>
  implements AfterViewInit {

  @Input() selStoreDetails?: any | null = null;
  @Input() vendorId?: string;
  @Input() selectedCategoryList: Category[] = [];
  @Input() storesByStates: any[] = [];
  @Input() identifiedStores?: string;

  @Output() storeFileSelected = new EventEmitter<any>();
  @Output() notifyIsoAdmin = new EventEmitter<any>();

  @ViewChild('storeFileInput') storeFileInput: ElementRef | undefined;

  showDialogBox = false;
  errorDetails: string = "";

  storeNos: string = '';
  validationStoreObject: any;
  inActiveStores: any[] = [];
  validStores: any[] = [];
  validStoresCount: number = 0;
  showModalPopup: boolean = false;
  selectedOption: string = '';
  rbtnLeft: boolean = false;
  rbtnRight: boolean = false;
  disableRightPannel: boolean | undefined;
  disableLeftPannel: boolean | undefined;

  addedStores: any[] = [];
  showModalPopupForStates: boolean = false;
  storeNumberByStatesString: string = '';
  //hasStoreValidationRun: boolean = false;
  hashawaiiStoreFound: boolean = false;

  showLoaderForValidateStores: boolean = false;
  isNewProject: boolean = false;

  constructor(projectService: ProjectService,
    storageService: StorageService,
    toastr: ToastrService,
    private ngxService: NgxUiLoaderService,
    private msgService: MessageService,
    private confirmationService: ConfirmationService,
    private unsavedChangesService: UnsavedChangesService,
    private emailService: EmailNotificationService
  ) {
    super(projectService, storageService, toastr);
  }

  onAnyFieldValueChange(e: boolean) {
    if (e) {
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  ngOnInit() {
    this.enableStoreRightSection();
    if (this.selectedFile != null
      && this.selectedFile!.projectFileID! > 0
    ) {
      this.fileName = this.selectedFile!.fileName!;
      this.isFileUploaded = true;
    }
  }

  enableStoreRightSection() {
    this.rbtnRight = true;
    this.disableRightPannel = false;
    this.rbtnLeft = false;
    this.disableLeftPannel = true;
  }

  enableStoreLeftSection() {
    this.rbtnLeft = true;
    this.disableLeftPannel = false;
    this.rbtnRight = false;
    this.disableRightPannel = true;
  }

  handleFileUpload(files: FileUploadModel): void {
    if (files) {
      //console.log('Uploaded files:', files);
    } else {
      //console.log('All files removed');
    }
  }

  ngAfterViewInit(): void {
    this.setFileInput(this.storeFileInput);
    this.setColumnsForValidation(["StoreID", "VendorID", "StoreNumber", "TDLINX", "StoreName", "IsActive", "Street", "City", "State", "Zip Code"]);
    this.setDownLoadFileName("StoresList");


    if (this.selectedFile != null
      && this.selectedFile != undefined) {
      this.fileName = this.selectedFile.fileName!;
    }
    else {
      this.selStoreDetails!.isStoreManual = true;

      if (!this.selStoreDetails?.storeListManual) {
        this.selStoreDetails.storeListManual = new ProjectFilesVm();
      }
      this.selStoreDetails!.storeListManual!.storeNumbers = '';
      this.fetchCopyStoreInfo();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedFile']) {

      if (this.selectedFile != null) {
        this.fileName = this.selectedFile!.fileName!;

        if (this.selectedFile?.rowsTotalCount != undefined
          && this.selectedFile?.rowsTotalCount != null
          && this.selectedFile?.rowsTotalCount > 0
        ) {
          this.displayTotalCount = "(" + this.selectedFile?.rowsTotalCount + ")";
        }

        this.isFileUploaded = true;
        this.selectedFile.storeNumbers = this.getStoreNumbers(this.selectedFile?.base64Bytes);

        this.enableStoreLeftSection();
      }
      else {
        this.clearFileDetails();
      }
    }

    if (changes['selStoreDetails']) {
      if (this.selStoreDetails?.isStoreManual) {
        this.enableStoreRightSection();
        this.storeNos = this.selStoreDetails!.storeListManual!.storeNumbers!.split(',').join('\n');
        this.fetchCopyStoreInfo();
        this.resetManualReject();
      }
    }
  }

  async onFileSelected(event: any): Promise<void> {
    const file: File = event.target.files?.[0];
    if (!file) return;

    const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}`;
    if (file.size > this.maxSize) {
      this.msgService.htmlError('File size cannot exceed 5 MB');
      this.clearFileDetails();
      return;
    }

    if (fileExtension !== '.xlsx') {
      this.msgService.htmlError('File type not allowed');
      this.clearFileDetails();
      return;
    }

    this.fileName = file.name;
    const isValid = await this.validateExcelFile1(file);
    if (!isValid || !this.selectedFile) return;

    // Set total count display if available
    if (this.totalCount) {
      this.displayTotalCount = `(${this.totalCount})`;
    }

    // Emit file details
    this.clearFileInput();
    this.unsavedChangesService.setUnsavedChanges(true);
    this.storeFileSelected.emit({ file, totalCount: this.totalCount, isValidatedStores: false, validatedStores: null });
  }

  async downLoadExcelPreview(event: Event) {
    this.ngxService.start();
    event.preventDefault(); // Prevent the default behavior (navigation)
    event.stopPropagation(); // Stop the event from bubbling up

    let blob = this.base64ToBlob(this.selectedFile?.base64Bytes!, this.contentType);

    this.downloadFile(blob);
    this.ngxService.stop();
  }

  async downLoadCopyStoreExcelPreview(event: Event) {
    this.ngxService.start();
    event.preventDefault(); // Prevent the default behavior (navigation)
    event.stopPropagation(); // Stop the event from bubbling up

    let blob = this.base64ToBlob(this.validationStoreObject?.fileContent!, this.validationStoreObject?.contentType);
    this.setDownLoadFileName("StoresList");
    this.downloadFile(blob);
    this.ngxService.stop();
  }

  downloadExcel(event: Event): void {
    event.preventDefault(); // Prevent the default behavior (navigation)
    event.stopPropagation(); // Stop the event from bubbling up

    if (!this.disableAfterReview) {
      if (this.vendorId === undefined) {
        console.error('Select the Vendor and try to download Excel file again.');
        this.toastr.error("Select the Vendor and try to download Excel file again.", "StoreList");
        this.ngxService.stop();
        return;
      }

      this.ngxService.start();
      let dLink = this.downloadLink;
      this.downloadLink = "Stores.xlsx"
      this.projectService.downloadStorelList(this.vendorId).subscribe((data) => {
        //this.downloadBlob = data;
        this.downloadFile(data);
        this.msgService.htmlSuccess('Store Excel file downloaded successfully.');
        this.ngxService.stop();

        this.downloadLink = dLink;
      });
    }
  }

  onCopyStoreDelete(): void {
    if (!this.disableAfterReview) {
      this.storeNos = '';
      this.validStoresCount = 0;
      this.selStoreDetails!.storeListManual!.storeNumbers = '';
      let fileData = {
        file: null,
        totalCount: this.validStoresCount == 0 ? -1 : this.validStoresCount,
        isValidatedStores: false,
        validatedStores: null
      }
      this.storeFileSelected.emit(fileData);
    }
  }

  updateStoreNosAndExcludeInvalidones() {
    this.errorDetails = "";
    // Extracting store numbers from the list of objects
    const storeNumbers = this.validStores?.map((store: { storeNumber: any; }) => store.storeNumber) || [];

    // Check if the storeNumbers array has items
    if (storeNumbers.length > 0) {
      // Join store numbers with newline '\n'
      this.storeNos = storeNumbers.join('\n');
      this.validStoresCount = storeNumbers.length;

      // Join store numbers with comma ',' for storeListManual
      this.selStoreDetails!.storeListManual!.storeNumbers = storeNumbers.join(',');
      let fileData = {
        file: null,
        totalCount: this.validStoresCount,
        isValidatedStores: true,
        validatedStores: storeNumbers.join(',')
      }

      this.hashawaiiStoreFound = this.onValidateHawaiiStores(storeNumbers.join(','));

      this.storeFileSelected.emit(fileData);
    } else {
      // Set storeNumbers to null if the array is empty
      this.selStoreDetails!.storeListManual!.storeNumbers = null;
      this.storeNos = '';
      this.validStoresCount = 0;
    }

    this.showModalPopup = true;
    setTimeout(() => {
      $('#staticBackdrop_four').modal("hide");
    }, 500);
  }

  onCLoseModal() {
    document.getElementById('staticBackdrop_four')!.style.display = 'none';
  }

  storeNosInput() {
    this.selStoreDetails!.storeListManual!.storeNumbers! = this.processStoreInput();
  }

  processStoreInput(): string {
    let commaSeparatedStores: string = '';

    // Split the input by new lines, trim each value, and filter out empty lines
    const storeArray: string[] = this.storeNos
      .split('\n')  // Split by new line
      .map(store => store.trim())  // Trim whitespace from each store number
      .filter(store => store);  // Remove empty lines

    // Join the array into a comma-separated string
    commaSeparatedStores = storeArray.join(', ');

    return commaSeparatedStores;
  }

  onRadioClick(option: string, event: any): void {
    const target = event.target;
    this.selectedOption = option;
    event.preventDefault();

    const isOption1 = option === "Option 1";
    const isOption2 = option === "Option 2";

    // Common logic for both options
    if (target.checked) {
      if (isOption1) {
        this.handleOption1(target, event);
      } else if (isOption2) {
        this.handleOption2(target);
      }
    }

    // Handle radio button state
    this.rbtnLeft = isOption1 || !isOption2;
    this.rbtnRight = !isOption1 || isOption2;
  }

  handleOption1(target: any, event: any): void {
    if (!this.selectedFile) {
      this.selectedFile = new ProjectFilesVm();
    }

    if (this.storeNos?.length) {
      this.showDialogStoreManual(target.checked, event);
    }
    else {
      this.resetPanelsForOption1();
    }
  }

  handleOption2(target: any): void {
    if (!this.selStoreDetails?.storeListManual) {
      this.selStoreDetails.storeListManual = new ProjectFilesVm();
    }

    if (this.selectedFile?.base64Bytes?.length) {
      this.showDialogStoreList(target.checked);
    } else {
      this.resetPanelsForOption2();
    }
  }

  resetPanelsForOption1(): void {
    this.enableStoreLeftSection();
    this.selStoreDetails!.isStoreManual = false;
    this.selStoreDetails!.storeListManual = null;
    this.errorDetails = "";
    this.storeNos = "";
  }

  resetPanelsForOption2(): void {
    this.enableStoreRightSection();
    this.selStoreDetails!.isStoreManual = true;
    this.selStoreDetails!.storeList = null;
    this.errorDetails = "";
    this.storeNos = "";

  }

  resetListAccept() {
    this.enableStoreRightSection();
    this.selStoreDetails!.isStoreManual = true;
    this.selStoreDetails!.storeList = null;
    this.errorDetails = "";
    this.storeNos = "";
    let fileData = {
      file: null,
      totalCount: -1,
      isValidatedStores: false,
      validatedStores: null
    }
    this.storeFileSelected.emit(fileData);
  }

  resetListReject() {
    this.enableStoreLeftSection();
    this.selStoreDetails!.isStoreManual = false;
    this.selStoreDetails!.storeListManual = null;
    this.errorDetails = "";
    this.storeNos = "";
  }

  resetManualAccept() {
    this.enableStoreLeftSection();
    this.selStoreDetails!.isStoreManual = false;
    this.selStoreDetails!.storeListManual = null;
    this.selectedFile = null;
    this.clearFileDetails();
    this.errorDetails = "";
    this.storeNos = "";
    this.validStoresCount = 0;
    let fileData = {
      file: null,
      totalCount: -1,
      isValidatedStores: false,
      validatedStores: null
    }
    this.storeFileSelected.emit(fileData);
  }

  resetManualReject() {
    this.enableStoreRightSection();
    this.selStoreDetails!.isStoreManual = true;
    this.selStoreDetails!.storeList = null;
    this.selectedFile = null;
    this.clearFileDetails();
    this.errorDetails = "";
  }

  showDialogStoreList(isChecked: boolean): void {
    this.confirmationService.confirm({
      header: "Stores Dialog",
      icon: 'pi pi-exclamation-triangle',
      message: "You are about to change the mode of adding Stores. If you have added any stores, those will be deleted.",
      accept: () => this.resetListAccept(),
      reject: () => this.resetListReject()
    });
  }

  showDialogStoreManual(isChecked: boolean, event: any): void {
    this.confirmationService.confirm({
      header: "Stores Dialog",
      icon: 'pi pi-exclamation-triangle',
      message: "You are about to change the mode of adding Stores. If you have added any stores, those will be deleted.",
      accept: () => this.resetManualAccept(),
      reject: () => this.resetManualReject()
    });
  }

  showReminderDialog() {

    if (this.refType == RefTypeEnum.Project && this.selStoreDetails.projectDetails.projectId > 0) {

      const project: ProjectDto = {
        projectID: this.selStoreDetails.projectDetails.projectId,
        vendorID: Number(this.vendorId),
        projectTitle: this.selStoreDetails.projectDetails.projectTitle,
        projectType: this.selStoreDetails.projectDetails.type,
        actionItem: ActionItems.STORES,
        userID: this.selStoreDetails.projectDetails.ctRequester
      };

      this.emailService.open(this.selectedCategoryList, project);
    }
    else if (this.refType == RefTypeEnum.Sales && this.selStoreDetails.salesplanDetails.salesplanId > 0) {

      const project: ProjectDto = {
        projectID: this.selStoreDetails.salesplanDetails.salesplanId,
        vendorID: Number(this.vendorId),
        projectTitle: this.selStoreDetails.salesplanDetails.projectTitle,
        projectType: this.refType,
        actionItem: ActionItems.STORES,
        userID: this.selStoreDetails.salesplanDetails.ctRequester
      };

      this.emailService.open(this.selectedCategoryList, project);
    }
    else {
      this.msgService.htmlError(ProjectConstants.VALIDATION_REMINDER_EMAIL);
    }
  }

  async fetchCopyStoreInfo() {

    let finalStoreNos = this.processStoreInput();

    if (finalStoreNos == '') {
      return;
    }

    const result = await this.validateStoreNumbers(finalStoreNos);
    if (!result) return;

    this.validationStoreObject = result;
    this.validStores = result.validStores;
    this.validStoresCount = this.validStores.length;

    let fileData = {
      file: null,
      totalCount: this.validStoresCount,
      isValidatedStores: true,
      validatedStores: this.validStores.map(s => s.storeNumber).join(',')
    }
    this.storeFileSelected.emit(fileData);
  }

  private clearFileInput(): void {
    if (this.storeFileInput) {
      this.storeFileInput.nativeElement.value = '';
    }
  }

  async btnValidateStore(): Promise<void> {
    this.errorDetails = ''; // Reset the previous error if any
    let selectedInputOption = '';

    if (this.rbtnLeft) {
      selectedInputOption = 'UPLOADSTORE';
    } else if (this.rbtnRight) {
      selectedInputOption = 'COPYSTORE';
    } else {
      return;
    }

    let finalStoreNos = '';
    if (selectedInputOption === 'UPLOADSTORE') {
      finalStoreNos = this.selectedFile?.storeNumbers ?? '';
    } else if (selectedInputOption === 'COPYSTORE') {
      finalStoreNos = this.processStoreInput();
    }

    if (!finalStoreNos) {
      return;
    }

    // Validate inactive & invalid stores
    const result = await this.validateStoreNumbers(finalStoreNos);
    if (!result) return;

    this.inActiveStores = [...result.inActiveStores, ...result.inValidStores];
    this.validationStoreObject = result;
    this.validStores = result.validStores;

    if (this.inActiveStores.length > 0) {
      const storeIds = this.inActiveStores.map(s => s.storeNumber).join(',');

      if (selectedInputOption === 'COPYSTORE') {
        this.showModalPopup = true;
        setTimeout(() => {
          $('#staticBackdrop_four').modal("show");
        }, 500);
      } else {
        this.errorDetails = `There are Invalid / Inactive stores. Please correct and try again. Store# are: ${storeIds}`;
        this.msgService.htmlError("There are Invalid / Inactive stores please correct and try to save again.");
      }
      return;
    }

    // Hawaii-specific validation
    this.hashawaiiStoreFound = this.onValidateHawaiiStores(finalStoreNos);

    let storeCount = this.validStores.length
    if (selectedInputOption === 'COPYSTORE') {
      this.validStoresCount = storeCount;
    }

    const fileData = {
      file: null,
      totalCount: storeCount,
      isValidatedStores: true,
      validatedStores: this.validStores.map(s => s.storeNumber).join(',')
    };
    this.storeFileSelected.emit(fileData);
  }

  private async validateStoreNumbers(storeNumbers: string): Promise<any> {
    this.inActiveStores = [];

    const inputVM = new StoreValidationRequestVM();
    inputVM.storeNubersList = storeNumbers;

    //this.showLoaderForValidateStores = true;
    this.ngxService.start();

    try {
      const result = await this.projectService.validateStoreNumbers(inputVM).toPromise();
      return result;
    } catch (error) {
      console.error('error:', error);
      this.msgService.htmlError("Store validation failed. Please try again.");
      return null;
    } finally {
      //this.showLoaderForValidateStores = false;
      this.ngxService.stop();
    }
  }

  private onValidateHawaiiStores(storeNumbers: string): boolean {
    if (!storeNumbers) return false;

    const identifiedStoresArray = this.identifiedStores
      ? this.identifiedStores.split(',').map(s => s.trim())
      : [];

    const storeNumbersArray = storeNumbers
      .split(',')
      .map(s => s.trim())
      .filter(num => !identifiedStoresArray.includes(num));

    if (!storeNumbersArray.length || !this.isStoresExistsOnState(storeNumbersArray.join(','))) {
      return false;
    }

    this.addedStores = this.storesByStates.filter(store =>
      storeNumbersArray.includes(store.storeNumber)
    );

    if (this.addedStores.length > 0 && !this.showModalPopupForStates) {
      this.storeNumberByStatesString = this.addedStores.map(store => store.storeNumber).join(', ');
      this.isNewProject = this.isNewProjectOrSalesPlan();
      this.showModalPopupForStates = true;     
      return true;
    }
    return false;
  }

  private isStoresExistsOnState(storeNumbers: string): boolean {
    if (!storeNumbers || this.storesByStates.length === 0) {
      return false;
    }

    const storeNumbersArray = storeNumbers.split(',').map(s => s.trim());
    return this.storesByStates.some(store => storeNumbersArray.includes(store.storeNumber));
  }

  notifyIsoAdminForStores() {
    this.showModalPopupForStates = false;
    this.notifyIsoAdmin.emit(this.storeNumberByStatesString);
  }

  private isNewProjectOrSalesPlan(): boolean {
    let isNewProjectOrSalesPlan = true;
    if (this.refType == RefTypeEnum.Project && this.selStoreDetails.projectDetails.projectId > 0) {
      isNewProjectOrSalesPlan = false;
    }
    else if (this.refType == RefTypeEnum.Sales && this.selStoreDetails.salesplanDetails.salesplanId > 0) {
      isNewProjectOrSalesPlan = false;
    }
    return isNewProjectOrSalesPlan;
  }

}
